import type { SystemStyleObject } from "@styled-system/css";

import React from "react";

import LegacyBox from "./LegacyBox";
import LegacyFlex from "./LegacyFlex";

type HorizontalLineWithContentProps = {
  containerSx?: SystemStyleObject;
  hrSx?: SystemStyleObject;
  childrenContainerSx?: SystemStyleObject;
  children?: React.ReactNode;
};

export default function HorizontalLineWithContent({
  containerSx,
  hrSx,
  childrenContainerSx,
  children = null,
}: HorizontalLineWithContentProps) {
  const containerSxMerged: SystemStyleObject = {
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    height: "21px",
    my: "medium",
    ...containerSx,
  };
  return (
    <LegacyFlex sx={containerSxMerged}>
      <LegacyBox
        sx={{
          borderBottom: "1px solid #DDDFE3",
          position: "absolute",
          top: "calc(50% - 1px)",
          width: "100%",
          zIndex: 1,
          ...hrSx,
        }}
      />
      <LegacyBox
        sx={{
          position: "relative",
          zIndex: 2,
          backgroundColor: "white",
          paddingLeft: "small",
          paddingRight: "small",
          ...childrenContainerSx,
        }}
      >
        {children}
      </LegacyBox>
    </LegacyFlex>
  );
}
